/**
 * =============================================================================
 * theme.js
 * =============================================================================
 * Entry point for all theme Javascript.
 * 
 * Before launching a site, consider what imports you actually need - i.e. which
 * parts of Bootstrap, which vendor JS imports, which Bootstrap plugins, etc.
 * =============================================================================
 */


// Imports from node_modules, installed via 'yarn add ...'
import * as bootstrap from 'bootstrap'; // Bootstrap (~79Kb)
import Swiper, { Navigation, Pagination, Autoplay, Thumbs, FreeMode } from 'swiper'; // Swiper (~78Kb)
import 'waypoints/lib/noframework.waypoints.min.js'; // Waypoints (intersection observer utility) (~10Kb)
import Cookies from 'js-cookie'; // Cookies.js (~2Kb)
//import AOS from 'aos'; // Animate on Scroll (~14Kb)
//import TomSelect from 'tom-select'; // TomSelect (~52Kb)
import PhotoSwipe from 'photoswipe'; // PhotoSwipe (~56Kb)

Swiper.use([Navigation, Pagination, Autoplay, Thumbs, FreeMode]);

// Export for others scripts to use by attaching to the window
window.bootstrap = bootstrap;
window.Swiper = Swiper;
window.Cookies = Cookies;
//window.TomSelect = TomSelect;
window.PhotoSwipe = PhotoSwipe;

// Initialisation
// AOS.init({
//   once: true
// });

// Imports from this folder - MP-specific - varies, but roughly ~45Kb
import MP from './mp';

import AsyncProductTiles from './async-product-tiles';
import BackInStock from './back-in-stock';
import Blog from './blog';
import Cart from './cart';
import Collection from './collection';
import CookieBar from './cookie-bar';
import CountdownManager from './countdown-manager';
import Facets from './facets';
import FGWP from './fgwp';
import GeoDetect from './geo-detect';
import GeoCartDelivery from './geo-cart-delivery';
import GeoNotifications from './geo-notifications';
import GeoProductBNPL from './geo-product-bnpl'
import GeoIPRedirect from './geo-ip-redirect'
import GeoProductDelivery from './geo-product-delivery';
import GeoProductRestrictions from './geo-product-restrictions';
import GtagHelper from './gtag-helper';
import LegacyBundles from './legacy-bundles';
import Localization from './localization';
import Nav from './nav';
// import ProductFormManager from './product-form-manager';
import ProductModels from './product-models';
import RecentlyViewed from './recently-viewed';
// import SailthruUtilities from './sailthru-utilities';
import SaveForLater from './save-for-later';

import ProductTile from "./product-tile";
customElements.define('product-tile', ProductTile);

import VideoSliderManager from './video-slider-manager'; 

// Export for others scripts to use by attaching to the window
MP.Extensions.AsyncProductTiles = AsyncProductTiles;
MP.Extensions.BackInStock = BackInStock;
MP.Extensions.Blog = Blog;
MP.Extensions.Cart = Cart;
MP.Extensions.Collection = Collection;
MP.Extensions.CookieBar = CookieBar;
MP.Extensions.CountdownManager = CountdownManager;
MP.Extensions.Facets = Facets;
MP.Extensions.FGWP = FGWP;
MP.Extensions.GeoDetect = GeoDetect;
MP.Extensions.GeoCartDelivery = GeoCartDelivery;
MP.Extensions.GeoNotifications = GeoNotifications;
MP.Extensions.GeoIPRedirect = GeoIPRedirect;
MP.Extensions.GeoProductBNPL = GeoProductBNPL;
MP.Extensions.GeoProductDelivery = GeoProductDelivery;
MP.Extensions.GeoProductRestrictions = GeoProductRestrictions;
MP.Extensions.GtagHelper = GtagHelper;
MP.Extensions.LegacyBundles = LegacyBundles;
MP.Extensions.Localization = Localization;
MP.Extensions.Nav = Nav;
// MP.Extensions.ProductFormManager = ProductFormManager;
MP.Extensions.ProductModels = ProductModels;
MP.Extensions.RecentlyViewed = RecentlyViewed;
// MP.Extensions.SailthruUtilities = SailthruUtilities;
MP.Extensions.SaveForLater = SaveForLater;
MP.Extensions.VideoSliderManager = VideoSliderManager;

// New style extensions
import WebVitals from './extensions/web-vitals';
//import DiscountkitHelper from './extensions/discountkit-helper';
try {
  MP.Extensions.WebVitals = new WebVitals("WebVitals");
  //MP.Extensions.DiscountkitHelper = new DiscountkitHelper("DiscountkitHelper");
} catch (e) {
  console.error("Error loading extensions:", e);
}

import CartWatcher from './utilities/cart-watcher';
try {
  MP.Utilities.CartWatcher = new CartWatcher();
  MP.Utilities.CartWatcher.init();
} catch (e) {
  console.error("Error loading utilities:", e);
}

/**
 * Load & define all custom elements in /elements using Webpack custom context
 */
const elementsContext = require.context('./elements', false, /\.js$/);
elementsContext.keys().forEach(file => {
  const moduleName = file.replace('./', '').replace('.js', ''); // Extract name from file
  const module = elementsContext(file);
  customElements.define(moduleName, module.default);
}); 

// Global functions
window.debounce = function(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Kickoff!
window.MP = Object.assign(MP, window.MP);
MP.init();